import { RatingResponse } from "../objects/rating";

const ratedReducerFunction = (state : RatingResponse | undefined | null, action : any) =>{

    switch(action.type) {        
        case "RATE_QUOTE":
            return (action.payload as RatingResponse);
    }
    
    return (state as RatingResponse) == undefined ? null : (state as RatingResponse);
};

export default ratedReducerFunction;